module.exports = __webpack_public_path__ + "static/media/1_18.ec59dea3.png";